import PropTypes from 'prop-types';

function IFWineInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11311)">
                <path
                    d="M18.1646 3.06412C20.7927 3.51086 22.9762 3.56196 23.0414 3.17826C23.1066 2.79456 21.0289 2.12136 18.4008 1.67462C15.7726 1.22788 13.5892 1.17677 13.524 1.56048C13.4588 1.94418 15.5364 2.61738 18.1646 3.06412Z"
                    fill="#F8F2ED"
                />
                <path
                    d="M13.5234 1.56065C13.5234 1.56065 9.95704 5.76106 10.4694 9.46011C10.9818 13.1592 14.5843 14.0565 14.727 15.1742C14.8697 16.292 15.2202 17.5869 14.6475 20.6752C14.0749 23.7635 13.6116 26.4888 13.3103 26.8656C13.0083 27.2424 12.0022 27.8478 10.5723 27.5926C9.5996 27.4191 9.30664 27.6746 9.00172 28.1614C8.82679 28.4411 11.0118 29.058 13.9093 29.5557C16.8039 30.053 18.8854 30.2352 18.8778 29.999C18.8703 29.7627 18.5769 28.7857 17.3049 28.7236C16.7408 28.6958 15.8653 28.3067 15.4486 27.9899C14.8274 27.5179 14.5507 26.8392 14.7235 25.8228C14.8963 24.8064 15.6609 19.4696 16.1971 17.992C16.7333 16.5145 17.1554 15.7109 18.0875 15.261C19.0196 14.811 21.4919 14.2576 22.5551 12.9371C23.4619 11.8111 23.8404 10.782 23.7956 7.9697C23.7507 5.15744 23.0411 3.17967 23.0411 3.17967"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.435 12.0884C12.7613 11.6012 12.2921 10.961 11.9501 10.203C11.6508 9.5391 11.6517 8.73138 11.7606 8.0636C11.8145 7.73273 11.8934 7.44614 11.968 7.24212C12.0056 7.13942 12.0402 7.06296 12.0672 7.01412C12.0705 7.00829 12.0734 7.00318 12.0761 6.99872C12.8286 6.73912 13.4241 6.69637 13.9255 6.77993C14.4394 6.86559 14.8755 7.0874 15.2984 7.38222C15.5819 7.57986 15.846 7.79967 16.1239 8.03097C16.2709 8.15322 16.4216 8.27868 16.5811 8.40577C17.0319 8.76491 17.5297 9.11642 18.133 9.36131C19.319 9.8428 20.3099 9.87407 21.0838 9.7646C21.469 9.71011 21.7973 9.62121 22.064 9.53906C22.1416 9.51515 22.2112 9.49282 22.2741 9.47239C22.1433 10.0367 21.8562 11.0381 21.3434 11.8056C21.0312 12.2728 20.3801 12.6663 19.466 12.9036C18.5599 13.1387 17.4306 13.2105 16.2139 13.0657C15.004 12.9218 14.1093 12.5762 13.435 12.0884ZM12.0922 6.97426C12.0952 6.97058 12.0949 6.97164 12.0913 6.97543C12.0917 6.97496 12.092 6.97457 12.0922 6.97426Z"
                    fill="#F8F2ED"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11311">
                    <rect width="30" height="30" fill="white" transform="translate(0.976562 0.584961)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFWineInactive;

IFWineInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFWineInactive.defaultProps = {
    className: null,
};
